import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { CircleEventForm } from "./CircleEventForm";
import { CircleEvent } from "@/types/circle";

interface CircleEventFormDialogProps {
  trigger?: React.ReactNode;
  event?: CircleEvent;
  onSuccess?: () => void;
}

export function CircleEventFormDialog({ trigger, event, onSuccess }: CircleEventFormDialogProps) {
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const defaultTrigger = (
    <Button size="icon" className="rounded-full bg-violet-500 hover:bg-violet-600 shadow-lg">
      <Plus className="w-5 h-5" />
    </Button>
  );

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        {trigger || defaultTrigger}
      </SheetTrigger>
      <SheetContent className="w-full sm:max-w-lg overflow-y-auto">
        <SheetHeader>
          <SheetTitle>{event ? "Edit Event" : "Lead an Event"}</SheetTitle>
          <SheetDescription>
            {event 
              ? "Update your Circle event details" 
              : "Create a new Circle event for the community"
            }
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6">
          <CircleEventForm event={event} onSuccess={handleSuccess} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
